import { push } from 'connected-react-router'
import { store } from 'duck/store'

export function goToRoute(route: string) {
  store.dispatch(push(route))
}
